import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { SettingService } from 'src/app/core/services/settings/settings.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink],
})
export class FooterComponent {

  copyright: Signal<string> = computed(() => this.settingsService.brandSettings().copyright)
  privacyPolicyLink: Signal<string> = computed(() => this.settingsService.brandSettings().privacyPolicyLink)

  constructor(
    private readonly settingsService: SettingService
  ) {
  }

}
